<!-- 조직관리 > 시스템알림관리 리스트 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt-total">Total: {{ totalCnt }}</div>
            <c-InputSearch :placeholder="t('message.searchMultiPlaceholder')"  v-model="inputSearch" @search-word="onClickSearch"/>
          </div>
          <div class="wr">
            <c-btn01 v-bind="btnNewUpload" @click="onClickViewPage4"/>
          </div>
        </div>
      </div>
      <!-- v-data-table 가져옴-->
      <div class="tbl-group size-custom3">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page-options="footerOptions"
          return-object
          @click:row="onClickViewPage4"
          :no-data-text="t('message.noRegisteredData')"
        >
          <template v-slot:item.idx="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.type="{ item }">
            {{ typeText(item.type) }}
          </template>
          <template v-slot:item.regDate="{ item }">
            <div class="ell01" >
              {{ dayjs(item.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD') }}
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>
<style lang="scss" >
</style>
<script setup lang="ts">
import {ref, onMounted, computed} from 'vue'
import {useCommonStore} from "@/store/common";
import BoardService from "@/services/board.service";
import utils from "@/common/Utils";
import {storeToRefs} from "pinia";
import {useRoute} from "vue-router";
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//bind
const snackbar = ref(false)
const snackText = ref('')
const totalCnt = ref(0)
const inputSearch = ref(null)
const selected = ref([])

//ui
const btnListDel = {
  btnText: t('message.selectDelete'),
  btnShow: true
}
const btnNewUpload = {
  btnText: t('message.newRegistration'),
}
const headers = computed(() =>([
  { title: t('message.orderNumber'), key: 'idx' },
  { title: t('message.type'), key: 'type' },
  { title: t('message.companyName'), key: 'companyName'},
  { title: t('message.author'), key: 'memberId' },
  { title: t('message.emailSendingStatus'), key: 'mailYn' },
  { title: t('message.sendingResult'), key: 'mailSendYn' },
  { title: t('message.sendingTime'), key: 'mailSendDate' },
  { title: t('message.registrationDate'), key: 'regDate' },
]))
const items = ref([])
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//hook
onMounted(() => {
  onClickSearch('')
})

//function
function onClickSearch(word){
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    keyword: word,
    companyIdx:companyIdx
  }

  BoardService.getBoardList(params).then(
    (response) => {
      items.value = response.result
      totalCnt.value = response.result.length
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onClickViewPage4(event, row){
  if(row)
    utils.movePage('/organizationalManagement/4/view/'+row.item.idx)
  else
    utils.movePage('/organizationalManagement/4/view/')
}

//computed
const typeText = computed(()=>(type:any) => {
  let result = ''
  if (type === '1') result = t('message.systemNotice')
  if (type === '2') result = t('message.groupNotice')
  if (type === '3') result = t('message.companyNotice')

  return result
})
</script>

